module.exports = __webpack_public_path__ + "static/media/eingangsbereich.4784aa81.jpg";